import React from 'react';
import { Link } from 'react-router-dom';
import { TrashIcon } from '@heroicons/react/24/outline';

const GroupsTable = ({
  chats,
  isLoading,
  selectedChats,
  onChatSelection,
  onSelectAllChats,
  onRemoveChat
}) => {
  if (isLoading) {
    return (
      <p className="text-gray-500 py-4">
        Loading project groups...
      </p>
    );
  }

  if (chats.length === 0) {
    return (
      <p className="text-gray-500 py-4">
        No groups associated with this project yet. Add groups to start monitoring messages.
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-6 py-3 text-left">
              <input
                type="checkbox"
                className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                checked={selectedChats.length === chats.length && chats.length > 0}
                onChange={(e) => onSelectAllChats(e.target.checked)}
              />
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Group Name
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Username
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Member Count
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Country
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Language
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Theme
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Assigned Via
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Assigned At
            </th>
            <th scope="col" className="relative px-6 py-3">
              <span className="sr-only">Actions</span>
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {Array.isArray(chats) ? chats.map((chat) => (
            <tr key={chat.chat_id} className="hover:bg-gray-50">
              <td className="px-6 py-4 whitespace-nowrap">
                <input
                  type="checkbox"
                  className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                  checked={selectedChats.includes(chat.chat_id)}
                  onChange={(e) => onChatSelection(chat.chat_id, e.target.checked)}
                />
              </td>
              <td className="px-6 py-4 whitespace-nowrap">
                <Link to={`/groups/${chat.chat_id}`} className="text-sm font-medium text-gray-900 hover:text-primary-600">
                  {chat.title}
                </Link>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {chat.chat_username || '-'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {chat.member_count || 'Unknown'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {chat.country || '-'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {chat.language || '-'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {chat.theme_name || '-'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <span className={`inline-flex rounded-full px-2 py-1 text-xs font-medium ${
                  chat.assignment_type === 'automatic'
                    ? 'bg-blue-100 text-blue-800'
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {chat.assignment_type || 'unknown'}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                {chat.assigned_at ? new Date(chat.assigned_at).toLocaleString() : '-'}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                <button
                  onClick={() => onRemoveChat(chat.chat_id)}
                  className="text-red-600 hover:text-red-900 inline-flex items-center"
                >
                  <TrashIcon className="h-4 w-4 mr-1" />
                  Remove
                </button>
              </td>
            </tr>
          )) : null}
        </tbody>
      </table>
    </div>
  );
};

export default GroupsTable;
